import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { PAYRUN_TYPE_ID, PersonaRole } from '@xemplo/gp-types';
import { useGetPayschedulesQuery } from '@xemplo/pay-schedule-query';
import { useGetCompanyUsersQueryV2 } from '@xemplo/users-query';

import { FormFields } from '../create-payrun-approvers.types';

import { ModalBodyProps } from './create-payrun-approvers-form.types';

export const useModalBody = (props: Readonly<ModalBodyProps>) => {
  const { companyId } = props;
  const { watch, setValue } = useFormContext<FormFields>();
  const { payrunType } = watch();

  const { data: users } = useGetCompanyUsersQueryV2({
    requestParams: {
      per_page: 500,
      page: 1,
      filter: {
        companyid: companyId,
        role: PersonaRole.CompanyAdmin,
        isEnabled: true,
        isActive: true,
      },
    },
  });

  const { data: payschedules } = useGetPayschedulesQuery({
    per_page: 500,
    page: 1,
    filter: { companyIds: [companyId] },
  });

  const usersData = useMemo(() => {
    if (!users?.result?.rows) return [];
    return users.result.rows.map((item) => ({
      key: item.id,
      value: `${item.firstName} ${item.lastName}`,
    }));
  }, [users]);

  const isPayScheduledEnabled = useMemo(
    () => payrunType === PAYRUN_TYPE_ID.SCHEDULED,
    [payrunType],
  );

  return {
    payschedulesData: isPayScheduledEnabled ? payschedules?.payScheduleItems : [],
    isPayScheduledEnabled,
    usersData,
    setValue,
  };
};
